import type { FieldDef, SectionMeta } from '../types';

export type CanvasBlock =
  | { kind: 'field'; field: FieldDef }
  | { kind: 'section'; section: SectionMeta; fields: FieldDef[] };

// Walks the ordered field list into render blocks: a loose field becomes a
// field block; a contiguous run sharing a sectionKey becomes one section block
// placed where the run begins. Mirrors the backend's top-level element walk.
const canvasLayout = (fields: FieldDef[], sections: SectionMeta[]): CanvasBlock[] => {
  const sectionByKey = new Map(sections.map((s) => [s.key, s]));
  const blocks: CanvasBlock[] = [];
  const emittedSections = new Set<string>();

  for (const field of fields) {
    const key = field.sectionKey;
    if (!key || !sectionByKey.has(key)) {
      blocks.push({ kind: 'field', field });
      continue;
    }
    if (emittedSections.has(key)) continue;
    emittedSections.add(key);
    blocks.push({
      kind: 'section',
      section: sectionByKey.get(key) as SectionMeta,
      fields: fields.filter((f) => f.sectionKey === key)
    });
  }

  return blocks;
};

export default canvasLayout;
